import React, { useContext } from "react";
import { CartContext } from "./CartContext";
import { ShoppingBagIcon } from "@heroicons/react/24/outline";
import { useUI } from "@/core/components/context/UIContext";

const CartIcon = () => {
  const { cartItems } = useContext(CartContext);
  const { toggleCart } = useUI();

  const itemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <button
      onClick={toggleCart}
      className="relative p-2 text-white focus:outline-none"
      aria-label="Shopping cart"
    >
      <ShoppingBagIcon className="h-6 w-6" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-cannabis-green-400 text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </button>
  );
};

export default CartIcon;
